// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1jZVa","box":"WorkspacesBox_box__24E0F","node":"WorkspacesBox_node__1hmWy"};